import axios from 'axios';
import qs from 'qs';

import endpoints from './endpoints';
import {handleResponse, handleRawResponse, handleError} from './utils';
import {basicAccessAuthHeader} from '../utils/mockAuthPG';

const paramsSerializer = params => qs.stringify(params);

export const getCompanyContact = () => {
    const url = endpoints.companyContact;
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
};

export const getCatalogue = (search, category, brand, page, limit) => {
    const url = endpoints.catalogue;
    const params = {
        search,
        category,
        brand,
        page,
        limit
    };
    return axios.get(url, {params})
        .then(handleResponse)
        .catch(handleError);
};

export const getCatalogueProduct = id => {
    const url = endpoints.catalogueProduct(id);
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
};

export const getCategories = () => {
    const url = endpoints.category;
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
};

export const getBrands = () => {
    const url = endpoints.brand;
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
};

export const getCustomerCart = (customerId, token) => {
    const url = endpoints.customerCart(customerId);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.get(url, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const addToCart = (customerId, token, item, quantity) => {
    const url = endpoints.customerCart(customerId);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    const params = {
        'variants':
            [
                {
                    'variant': item,
                    'quantity': quantity
                }
            ]
    };
    return axios.post(url, params, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const updateCart = (id, token, params) => {
    const url = endpoints.customerCart(id);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.put(url, params, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const checkoutCart = (id, token, params) => {
    const url = endpoints.checkoutCart(id);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.post(url, params, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const addFeedback = (name, email, message, type) => {
    const url = endpoints.feedback;
    const data = {
        name: name,
        email: email,
        contact_type: type,
        message: message
    };
    return axios.post(url, data)
        .then(handleResponse)
        .catch(handleError);
};

export const addSubscription = (email) => {
    const url = endpoints.subscribe;
    const data = {
        email,
    };
    return axios.post(url, data)
        .then(handleResponse)
        .catch(handleError);
};

export const addPrescription = (name, number, type, prescription) => {
    const url = endpoints.feedback;
    const data = {
        name: name,
        whatsapp_number: number,
        contact_type: type,
        prescription: prescription
    };
    return axios.post(url, data)
        .then(handleResponse)
        .catch(handleError);
};

export const loginCustomer = (email, password) => {
    const url = endpoints.loginCustomer;
    const data = {
        email: email,
        password: password
    };
    return axios.post(url, data)
        .then(handleResponse)
        .catch(handleError);
};

export const registerCustomer = (firstName, lastName, email, password, repeatPassword) => {
    const url = endpoints.registerCustomer;
    const data = {
        first_name: firstName,
        last_name: lastName,
        email: email,
        password: password,
        confirm_password: repeatPassword
    };
    return axios.post(url, data)
        .then(handleResponse)
        .catch(handleError);
};

export const getCustomerProfile = (id, token) => {
    const url = endpoints.customerProfile(id);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.get(url, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const updateCustomerProfile = (id, token, params) => {
    const url = endpoints.editCustomerProfile(id);
    const headers = {
        Authorization: `Bearer ${token}`
    };

    return axios.put(url, params, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const getProfessional = (token, search, page, limit) => {
    const url = endpoints.professionals;
    const headers = {
        Authorization: `Bearer ${token}`
    };
    const params = {
        search,
        page,
        limit
    };
    return axios.get(url, {
        headers,
        params
    })
        .then(handleResponse)
        .catch(handleError);
};

export const getCustomerOrders = (customerId, token, search, page, limit) => {
    const url = endpoints.customerOrders(customerId, token);
    const params = {
        search,
        page,
        limit
    };
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.get(url, {
        headers,
        params
    })
        .then(handleResponse)
        .catch(handleError);
};

export const getCustomerOrder = (customerId, orderId, token) => {
    const url = endpoints.customerOrder(customerId, orderId, token);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.get(url, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const uploadResourceFile = (token, file) => {
    const url = endpoints.resourceFiles;

    const formData = new FormData();
    formData.append('file', file);

    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
    };

    return axios.post(url, formData, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const getTicketOrders = (token, search, page, limit, sort, filter) => {
    const url = endpoints.ticketOrders;
    const params = {
        search,
        page,
        limit,
        sort,
        filter
    };
    const headers = {
        Authorization: `Bearer ${token}`
    };

    return axios.get(url, {
        params,
        headers,
        paramsSerializer
    })
        .then(handleResponse)
        .catch(handleError);
};

export const getResourceFile = resourceId => endpoints.resourceFile(resourceId);

export const adminToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmaXJzdF9uYW1lIjoiSG93YXJkIiwibGFzdF9uYW1lIjoiRWR3YXJkcyIsImVtYWlsIjoiaG93YXJkLmVkd2FyZHNAc21zamEubmV0IiwidXNlcl9pZCI6IjVlNzE4MjFhZDc0NzM4NWRmOTkyMTZmMCIsInJvbGVfaWQiOiI1ZTczYzA4NzYxMTUyNDMyZjM4OGIwODkiLCJpYXQiOjE1OTI5NTMxMTAsImV4cCI6MTU5NTU0NTExMH0.iZVzm6NkayyuOMC__2oJwSEjkgXYG_ypbGqIBEBq5EE";

export const getOrders = (token,id) => {
    const url = endpoints.adminOrder(id);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.get(url,{headers})
        .then(handleResponse)
        .catch(handleError)
};

// Admin
export const getNotifications = (token) => {
    const url = endpoints.adminNotifications;
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.get(url,{headers})
        .then(handleResponse)
        .catch(handleError)
};

export const editNotifications = (token,id,params) => {
    const url = endpoints.changeNotifications(id);
  
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.post(url,params,{headers})
        .then(handleResponse)
        .catch(handleError)
};
export const loginUser = (email, password) => {
    const url = endpoints.loginUser;
    const data = {
        email: email,
        password: password
    };
    return axios.post(url, data)
        .then(handleResponse)
        .catch(handleError);
};

export const getAdminBrands = (token) => {
    const url = endpoints.adminBrands;
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.get(url, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const getAdminOrders = (token, search, page, limit, sort, filter) => {
    const url = endpoints.adminOrders;
    const params = {
        search,
        page,
        limit,
        sort,
        filter
    };
    const headers = {
        Authorization: `Bearer ${token}`
    };

    return axios.get(url, {
        params,
        headers,
        paramsSerializer
    })
        .then(handleResponse)
        .catch(handleError);
};

export const updateAdminOrder = (token, id, params) => {
    const url = endpoints.adminOrder(id);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.put(url, params, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const deleteAdminOrder = (token, id) => {
    const url = endpoints.adminOrder(id);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.delete(url, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const getAdminCustomers = (token, search, page, limit, sort, filter) => {
    const url = endpoints.adminCustomers;
    const params = {
        search,
        page,
        limit,
        sort,
        filter
    };
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.get(url, {
        params,
        headers,
        paramsSerializer
    })
        .then(handleResponse)
        .catch(handleError);
};

export const updateAdminCustomer = (token, id, params) => {
    const url = endpoints.adminCustomer(id);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.put(url, params, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const deleteAdminCustomer = (token, id) => {
    const url = endpoints.adminCustomer(id);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.delete(url, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const getAdminProduct = (token, id) => {
    const url = endpoints.adminProduct(id);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.get(url, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const addAdminProduct = (token, data) => {
    const url = endpoints.adminProducts;
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.post(url, data, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const updateAdminProduct = (token, id, data) => {
    const url = endpoints.adminProduct(id);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.put(url, data, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const updateAdminProductVariants = (token, id, data) => {
    const url = endpoints.adminProductVariants(id);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.put(url, data, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const getAdminProducts = (token, search, page, limit) => {
    const url = endpoints.adminProducts;
    const params = {
        search,
        page,
        limit
    };
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.get(url, {
        params,
        headers
    })
        .then(handleResponse)
        .catch(handleError);
};

export const getAdminVariants = (token, search, page, limit, sort, filter) => {
    const url = endpoints.adminVariants;
    const params = {
        search,
        page,
        limit,
        sort,
        filter
    };
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.get(url, {
        params,
        headers,
        paramsSerializer
    })
        .then(handleResponse)
        .catch(handleError);
};

export const updateAdminVariant = (token, productId, variantId, data) => {
    const url = endpoints.adminVariant(productId, variantId);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.put(url, data, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const deleteAdminVariant = (token, productId, variantId) => {
    const url = endpoints.adminVariant(productId, variantId);
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.delete(url, {headers})
        .then(handleResponse)
        .catch(handleError);
};

export const getAdminCustomerOrders = (customerId, token, page, limit) => {
    const url = endpoints.adminCustomerOrders(customerId);
    const params = {
        page,
        limit
    };
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return axios.get(url, {
        params,
        headers
    })
        .then(handleResponse)
        .catch(handleError);
};

export const checkoutTransaction = params => {
    const url = endpoints.checkout;
    const headers = {
        Authorization: basicAccessAuthHeader
    };
    return axios.post(url, params, {headers})
        .then(handleResponse)
        .catch(handleError);
};

//Offers
export const getAdminOffers = params => {
    const url = endpoints.adminOffers;
    return axios.get(url, params)
        .then(handleResponse)
        .catch(handleError);
};
export const getAllReviews = (searchText, limit, page, product_id,sortOrder, sortBy) => {
    const url = endpoints.review;
    const params = {
        searchText,
        limit,
        page,
        product_id,
        sortOrder,
        sortBy

    };
    // const headers = {
    //     Authorization: `Bearer ${token}`
    // };
    return axios.get(url, {params})
        .then(handleResponse)
        .catch(handleError);
};
export const getAdminOfferById = id => {
    const url = endpoints.adminOffer(id);
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
};
export const addAdminOffer = params => {
    const url = endpoints.adminOffers;
    return axios.post(url, params)
        .then(handleResponse)
        .catch(handleError);
};
export const getReview = (id) => {
    const url = endpoints.reviewId(id);
    // const headers = {
    //     Authorization: `Bearer ${token}`
    // };
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
};
export const updateAdminOfferById = (id, params) => {
    const url = endpoints.adminOffer(id);
    return axios.put(url, params)
        .then(handleResponse)
        .catch(handleError);
};
export const updateReview = (id, data) => {
    const url = endpoints.reviewId(id);
    // const headers = {
    //     Authorization: `Bearer ${token}`
    // };
    return axios.put(url, data)
        .then(handleResponse)
        .catch(handleError);
};
export const deleteAdminOfferById = (id) => {
    const url = endpoints.adminOffer(id);
    return axios.delete(url)
    .then(handleResponse)
    .catch(handleError);
};


export const deleteReview = (id) => {
    const url = endpoints.reviewId(id);
    // const headers = {
    //     Authorization: `Bearer ${token}`
    // };
    return axios.delete(url)
        .then(handleResponse)
        .catch(handleError);
};
export const addReview = (data) => {
    const url = endpoints.review;
    // const headers = {
    //     Authorization: `Bearer ${token}`
    // };
    return axios.post(url, data)
        .then(handleResponse)
        .catch(handleError);
};
//Announcements
export const getAdminAnnouncements = params => {
    const url = endpoints.adminAnnouncements;
    return axios.get(url, params)
        .then(handleResponse)
        .catch(handleError);
};
export const addAdminAnnouncement = params => {
    const url = endpoints.adminAnnouncements;
    return axios.post(url, params)
        .then(handleResponse)
        .catch(handleError);
};
export const getAdminAnnouncementById = id => {
    const url = endpoints.adminAnnouncement(id);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
};
export const getAllAdminReviews = (searchText, limit, page, product_id,sortOrder, sortBy) => {
    const url = endpoints.adminReview;
    const params = {
        searchText,
        limit,
        page,
        product_id,
        sortOrder,
        sortBy

    };
    // const headers = {
    //     Authorization: `Bearer ${token}`
    // };
    return axios.get(url, {params})
        .then(handleResponse)
        .catch(handleError);
};
export const getAdminReview = (id) => {
    const url = endpoints.adminReviewId(id);
    // const headers = {
    //     Authorization: `Bearer ${token}`
    // };
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
};
export const updateAdminAnnouncementById = (id, params) => {
    const url = endpoints.adminAnnouncement(id);
    return axios.put(url, params)
        .then(handleResponse)
        .catch(handleError);
};
export const deleteAdminAnnouncementById = (id) => {
    const url = endpoints.adminAnnouncement(id);
    return axios.delete(url)
        .then(handleResponse)
        .catch(handleError);
};

export const updateAdminReview = (id, data) => {
    const url = endpoints.adminReviewId(id);
    // const headers = {
    //     Authorization: `Bearer ${token}`
    // };
    return axios.put(url, data)
        .then(handleResponse)
        .catch(handleError);
};
export const addAdminReview = (data) => {
    const url = endpoints.adminReview;
    // const headers = {
    //     Authorization: `Bearer ${token}`
    // };
    return axios.post(url, data)
        .then(handleResponse)
        .catch(handleError);
};

export const deleteAdminReview = (id) => {
    const url = endpoints.adminReviewId(id);
    // const headers = {
    //     Authorization: `Bearer ${token}`
    // };
    return axios.delete(url)
        .then(handleResponse)
        .catch(handleError);
};
